import { useDeleteFeeServiceMutation } from '@/pages/Fleet/Businesses/services/fee-services.service';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { useNotification } from '@/hooks';
import { getErrorMessage } from '@/utils/errorUtils';
import { useCallback } from 'react';

const SUCCESS_MESSAGE = 'Servicio eliminado correctamente';
const DEFAULT_ERROR_MESSAGE = 'No se pudo eliminar el servicio.';

const useDeleteService = () => {
  const { showNotification } = useNotification();
  const [deleteFeeService, { isLoading: isDeleting }] = useDeleteFeeServiceMutation();

  const executeDelete = useCallback(
    (id: string) => {
      return deleteFeeService({ id })
        .unwrap()
        .then(() => {
          showNotification(SUCCESS_MESSAGE, NotificationSeverity.success);
        })
        .catch((error) => {
          const message = getErrorMessage(error, DEFAULT_ERROR_MESSAGE);
          showNotification(message, NotificationSeverity.error);
        });
    },
    [deleteFeeService, showNotification]
  );

  return { executeDelete, isDeleting };
};

export default useDeleteService;
